import { Component, Input, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { DeadlineNotice, deadlineNotice, formatDeadline, parseDeadline } from './password-deadline';

/**
 * "You have N days left to set your new password" (ZEY-3140), under the explanation of the popup and of the
 * /change-password form. Shows nothing without a deadline.
 */
@Component({
  selector: 'app-password-deadline',
  standalone: true,
  imports: [TranslateModule],
  template: `
    @if (notice; as n) {
      <p class="pw-deadline" [class.pw-deadline--passed]="n.key === 'passwordDeadlinePassed'" role="status" dir="auto">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
        <span [innerHTML]="n.key | translate: { days: n.days, date: date }"></span>
      </p>
    }
  `,
  styleUrls: ['./password-deadline.component.scss']
})
export class PasswordDeadlineComponent {
  private readonly translate = inject(TranslateService);

  /** `YYYY-MM-DD`, as the API sends it; null = no countdown. */
  @Input() deadline: string | null = null;

  get notice(): DeadlineNotice | null {
    return deadlineNotice(this.deadline);
  }

  get date(): string {
    const deadline = parseDeadline(this.deadline);
    return deadline ? formatDeadline(deadline, this.translate.currentLang) : '';
  }
}
